export interface State {
    width: number;
    height: number | null;
    offsetTop: number;
    webviewOs: string | boolean;
    tabVisible: boolean;
}

export const initialState: State = {
    width: 1024,
    height: null, // @TODO why null
    offsetTop: 0,
    webviewOs: false,
    tabVisible: false,
};
